import { gql } from 'graphql-tag';

export const AddressInfoFragment = gql`
  fragment AddressInfo on AddressType {
    address1
    address2
    city
    postalCode
    state
    country {
      code
      label
    }
  }
`;
